App.controller('HealthPzuwFacilityCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurancePzuw_facility';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Placówki medyczne';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.health.start';
    $scope.$emit('link', $scope.link);
}]);
